function handleVideo(containerSelector, mediaWrapperSelector) {
  const blocks = document.querySelectorAll(containerSelector);

  if (blocks) {
    blocks.forEach((block) => {
      const sectionMedias = block.querySelectorAll(mediaWrapperSelector);

      if (sectionMedias) {
        sectionMedias.forEach((sectionMedia) => {
          let mediaType;
          if (sectionMedia.querySelector('.media__video')) {
            mediaType = 'video';
            const poster = sectionMedia.querySelector('img');
            if(!poster) {
              return;
            }
            const playButton = sectionMedia.querySelector('.play-button');
            const video = sectionMedia.querySelector('video');
            poster.addEventListener('click', (e) => {
              if (!poster.classList.contains('is-hidden')) {
                poster.classList.add('is-hidden');
                if(video.autoplay) {
                  video.play();
                }
              }

              if (!playButton.classList.contains('is-hidden')) {
                playButton.classList.add('is-hidden');
              }
            });

            playButton.addEventListener('click', (e) => {
              if (!poster.classList.contains('is-hidden')) {
                poster.classList.add('is-hidden');
                 if(video.autoplay) {
                  video.play();
                }
              }

              if (!playButton.classList.contains('is-hidden')) {
                playButton.classList.add('is-hidden');
              }
            });

          }
        });
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
    handleVideo('.wp-block-lb-image-text', '.section__media');
});
